/**
 * Public surface of the analytics module.
 */

export { useAnalytics } from './use-analytics';
export type { Analytics } from './use-analytics';

export { AnalyticsProvider } from './provider';
export { useZoneGroup } from './use-zone-group';

export { ANALYTICS_EVENTS } from './events';
export type {
  AnalyticsEventName,
  AnalyticsEventKey,
  TypedEventProps,
} from './events';

export {
  initAnalytics,
  getPostHog,
  captureEvent,
  captureException,
} from './lib/posthog-client';
